ko.bindingHandlers.upDown = {
    init: function (element, valueAccessor, allBindings, viewModel, bindingContext)
    {
        
        const options = ko.unwrap(valueAccessor());
        const eventHandler = (e) =>
        {
            if (e.key === 'ArrowDown') {
                e.currentTarget.nextElementSibling?.focus()
                e.preventDefault()
            }
            if (e.key === 'ArrowUp') {
                e.currentTarget.previousElementSibling?.focus()
                e.preventDefault()
            }

            //viewmodel has an 'click' function
            if (e.key ==='Enter' && options.enterKey) {
                options.enterKey(viewModel, e);

            }
        }

        element.addEventListener('keyup', eventHandler);
        element.tabIndex = 0;

        ko.utils.domNodeDisposal.addDisposeCallback(element, () =>
        {
            element.removeEventListener('keyup', eventHandler)
        });

    }
}